import React, { memo } from "react";
import { API } from "../../BackendConnections"
import {
  ComposableMap,
  Geographies,
  Geography,
  ZoomableGroup,
  Marker,
} from "react-simple-maps";
import { connect } from "react-redux";
import ReactTooltip from "react-tooltip"; // Import ReactTooltip

export const MyContactsLocation = ({ locationMap }) => {
  const geoUrl = `${API}/media/world-countries.json`;

  return (
    <>
      <div className="row mb-3 margin-minus mynetwork-page">
        {window.location.pathname === "/user/dashboard" ? (
          <div className="col-12" style={{ color: "#283270" }}>
            {" "}
            MY <strong>Network by Location</strong>
            <h2 className="block-title " ></h2>
          </div>
        ) : window.location.pathname === "/user/profile-analytics" ? (
          <div className="col-12">
            <h className="text-light" style={{ fontSize: "14px" }}>
              {" "}
              <small style={{ fontSize: "14px" }}>MY</small> <strong>Network Location</strong>
            </h>
          </div>
        ) : (
          <div className="col-12 dashboard-wrap"style={{ color: "#283270",paddingBottom:'0',paddingTop:'0',paddingLeft:'0' }}>
            <div className="right-section " style={{paddingLeft:'15px'}}>
              <div className="block-title">
      
            MY Network by Location
       
              </div>
            </div>
           
          </div>
        )}
      </div>
      <div className="row contacts-by-location mb-4">
        <div className="col-12 mb-2">
          <ComposableMap
            style={{
              height:
                window.location.pathname === "/user/network"
                  ? "500px"
                  : "240px",
              width: "100%",
            }}
            projectionConfig={{ scale: 225 }}
          >
            <ZoomableGroup zoom={1}>
              <Geographies geography={geoUrl} fill="#F9C671" stroke="#F59E0D">
                {({ geographies }) =>
                  geographies.map((geo) => (
                    <Geography
                      key={geo.rsmKey}
                      geography={geo}
                      style={{
                        default: {
                          fill: "#F4D39F",
                          outline: "none",
                        },
                        hover: {
                          fill: "#F9C671",
                          outline: "none",
                        },
                        pressed: {
                          fill: "#E42",
                          outline: "none",
                        },
                      }}
                    />
                  ))
                }
              </Geographies>
              {locationMap.map(({ name, coordinates, markerOffset, users }) => (
                <Marker
                  key={name}
                  coordinates={coordinates}
                  onMouseEnter={() => {
                    ReactTooltip.show();
                    ReactTooltip.rebuild();
                  }}
                  onMouseLeave={() => {
                    ReactTooltip.hide();
                  }}
                  data-tip={`${name} - ${users.join(", ")}`} // Set the tooltip content here
                >
                  <circle r={5} fill="#26336E" stroke="#fff" strokeWidth={1} />
                </Marker>
              ))}
            </ZoomableGroup>
          </ComposableMap>
        </div>
      </div>
      {/* Add ReactTooltip component */}
      <ReactTooltip />
    </>
  );
};

const mapStateToProps = (state) => {
  const locationMap = state.network.locationMap;
  return {
    locationMap: locationMap,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(MyContactsLocation);
